import { render, staticRenderFns } from "./JobBoxWithoutTabs.vue?vue&type=template&id=18140766&"
import script from "./JobBoxWithoutTabs.vue?vue&type=script&lang=js&"
export * from "./JobBoxWithoutTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseJobBoxList: require('/usr/src/app/components/base/JobBoxList.vue').default,SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
